module.exports = __webpack_public_path__ + "static/media/img_socialmedia-01FB.8c277907.png";